import { Fragment, ReactElement } from 'react';

import {
  Avatar,
  IconButton,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { formatDateForLocale } from '@/utils';

import { Transaction } from '../types';

export const TransactionsTableRow = (props: Transaction): ReactElement => {
  const formattedDateAndTime = formatDateForLocale(props.dateAndTime);

  return (
    <Fragment>
      <TableRow>
        {/* ID */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            #{props.id}
          </Typography>
        </TableCell>

        {/* Date and Time */}
        <TableCell>{formattedDateAndTime}</TableCell>

        {/* Reference Number */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.referenceNumber}
          </Typography>
        </TableCell>

        {/* Ticket */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            <Stack direction="row" alignItems="center" gap={1} fontSize={12}>
              <Avatar sx={{ width: 32, height: 32 }}>N</Avatar>
              {props.ticket}
            </Stack>
          </Typography>
        </TableCell>

        {/* Email */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.email}
          </Typography>
        </TableCell>

        {/* Status */}
        <TableCell>
          <Typography maxWidth="50ch" fontSize="inherit">
            {props.status}
          </Typography>
        </TableCell>

        {/* Action button(s) */}
        <TableCell>
          <Stack direction="row" spacing={0.5}>
            <IconButton aria-label="Action Button" size="small" color="inherit">
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
            <IconButton aria-label="View Button" size="small" color="inherit">
              <RemoveRedEyeOutlinedIcon fontSize="small" />
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};
